export const Loader = () => {
  return (
    <span className="loading loading-spinner text-violet-500 flex mx-auto h-[200px] scale-[2]"></span>
  );
};
